export interface AuthTokenResponse {
  accessToken: string;
  refreshToken: string;
  expiresIn: number;
}

export interface UserSession {
  id: string;
  authProvider: string;
  clientType?: string | null;
  userAgent?: string | null;
  ipAddress?: string | null;
  createdAt: string;
  lastUsedAt: string;
  expiresAt: string;
  revokedAt?: string | null;
}

export interface DeveloperCredential {
  id: string;
  clientId: string;
  displayName: string;
  createdAt: string;
  lastUsedAt?: string | null;
  expiresAt: string;
  revokedAt?: string | null;
}

export interface CreatedDeveloperCredential extends DeveloperCredential {
  clientSecret: string;
}

export interface ServiceAccount {
  id: string;
  displayName: string;
  description?: string | null;
  active: boolean;
  canImpersonate: boolean;
  source: string;
  backingUserId: string;
  roleIds: string[];
  roleNames: string[];
  roleEntity?: string | null;
  createdAt: string;
  modifiedAt: string;
  ownerUserIds: string[];
  credentials: DeveloperCredential[];
}

export interface CreateDeveloperCredentialRequest {
  displayName: string;
  lifetimeDays?: number | null;
}

export interface CreateMachineCredentialRequest {
  displayName: string;
  expiresAtUtc?: string | null;
}

export interface CreateServiceAccountRequest {
  displayName: string;
  description?: string | null;
  canImpersonate: boolean;
  ownerUserIds: string[];
  roleIds: string[];
  roleEntity?: string | null;
}

export interface UpdateServiceAccountRequest extends CreateServiceAccountRequest {
  active: boolean;
}
